import { POIInfo } from "../../common/Common";
import styles from "./POIListItem.module.css";
import viewStyles from "./POIListView.module.css";
import UserActivityInfo from "../../common/UserActivityInfo";
import { MouseEvent } from "react";

export type InfoCount = "view" | "story" | "bookmark" | "like";

interface POIListItemProps {
    item: POIInfo;
    selected: boolean;
    onClickItem: (e: MouseEvent<HTMLElement>) => void;
}

const POIListItem = ({ item, ...props }: POIListItemProps) => {
    return (
        <div id={`poi_${item.XID}`} className={`${styles.container} ${props.selected ? viewStyles.selected : ""}`} onClick={props.onClickItem}>
            <div className={`${item.placeName === "" ? styles.no_title : styles.title}`}>
                {item.placeName === "" ? "(장소 이름 없음)" : item.placeName}
            </div>
            <div className={`${styles.address} ${!item.address ? styles.no_data : ""}`}>{item.address ?? "(주소 정보 없음)"}</div>
            <div className={styles.actions}>
                <UserActivityInfo count={item.viewCnt} type="view" size="small" />
                <UserActivityInfo count={item.storyCnt} type="chat" size="small" />
            </div>
        </div>
    );
};

export default POIListItem;
